/**
 * DesktopMenu Module
 * helper class
 */
export default class {
  /**
   * constructor
   * @param {Object} options
   */
  constructor(options = {}) {
    this.options = {
      dropdownContainerSelector: '[data-dropdown-container]',
      dropdownContentSelector: '[data-dropdown-id]',
      dropdownTriggerSelector: '[data-trigger-dropdown-id]',
      dropdownTriggerAttribute: 'triggerDropdownId',
      dropdownIconSelector: '[data-dropdown-icon]',
      dropdownOpenContentCss: 'desktop-menu__dropdown--open',
      dropdownOpenIconCss: 'desktop-menu__dropdown-icon--open',
      ...options,
    };

    this.dropdownContents = document.querySelectorAll(this.options.dropdownContentSelector);
    this.dropdownIcons = document.querySelectorAll(this.options.dropdownIconSelector);
    this.dropdownTriggers = document.querySelectorAll(this.options.dropdownTriggerSelector);

    this.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.eventType = this.iOS ? 'touchstart' : 'mousedown';

    this.dropdownTriggers.forEach((el) => {
      el.addEventListener(this.eventType, (event) => this.handleDropdownClick(event));
      el.addEventListener('focus', (event) => this.handleDropdownFocus(event));
    });

    window.addEventListener('click', (event) => this.handleGlobalClick(event));
  }

  /**
   * Close all dropdowns: swap icon and hide content
   */
  closeAllDropdowns() {
    this.dropdownContents.forEach((dropdown) => {
      dropdown.classList.remove(this.options.dropdownOpenContentCss);
    });
    this.dropdownIcons.forEach((dropdown) => {
      dropdown.classList.remove(this.options.dropdownOpenIconCss);
    });
  }

  /**
   * handleDropdownClick
   * lend from @see https://stackoverflow.com/questions/48914111/multiple-dropdown-buttons-only-one-open-at-a-time-js-jquery
   * @desc opens/closes dropdown menus when clicked
   * @param {Event} event
   */
  handleDropdownClick({ target }) {
    const thisDropdownIcon = target.querySelector(this.options.dropdownIconSelector);

    if (!thisDropdownIcon.classList.contains(this.options.dropdownOpenIconCss)) {
      // Added to hide dropdown if clicking on the one already open
      this.closeAllDropdowns();
    }

    // Toggle the dropdown on the element clicked
    const container = target.closest(this.options.dropdownContainerSelector);
    if (container) {
      container.querySelector(this.options.dropdownContentSelector)
        .classList.toggle(this.options.dropdownOpenContentCss);

      container.querySelector(this.options.dropdownIconSelector)
        .classList.toggle(this.options.dropdownOpenIconCss);
    } else {
      console.debug('Could not find closest container for given target.');
    }
  }

  /**
   * handleDropdownFocus
   * @desc opens dropdown menus when focusing
   * @param {Event} event
   */
  handleDropdownFocus({ target }) {
    document
      .querySelector(`[data-dropdown-id="${target.dataset[this.options.dropdownTriggerAttribute]}"]`)
      .classList
      .add(this.options.dropdownOpenContentCss);

    target
      .querySelector(this.options.dropdownIconSelector)
      .classList
      .add(this.options.dropdownOpenIconCss);
  }

  /**
   * Function to close the dropdown when clicked outside.
   * @see https://stackoverflow.com/questions/48914111/multiple-dropdown-buttons-only-one-open-at-a-time-js-jquery
   * @param {Event} event
   */
  handleGlobalClick(event) {
    if (!event.target.matches(this.options.dropdownTriggerSelector)) {
      this.closeAllDropdowns();
    }
  }
}
